import { useMemo, useState } from "react";

/**
 * Controller for the annotation context
 *
 * @returns {{
 *    annotations: Annotation[],
 *    setAnnotations: (Annotation[]) => void,
 *    selectedAnnotation: Annotation,
 *    setSelectedAnnotation: (Annotation) => void,
 *    imageSrc: String,
 *    deleteAnnotation: (Number) => void
 * }}
 */

export const useAnnotationContextController = () => {
  const [annotations, setAnnotations] = useState([])
  const [selectedAnnotation, setSelectedAnnotation] = useState(null)
  const [selectedImageIndex, setSelectedImageIndex] = useState(0)

  const imageSrc = useMemo(() => `/videos/frames/${String(selectedImageIndex + 1).padStart(4, '0')}.jpg`,
      [selectedImageIndex])


  const deleteAnnotation = (index) => {
    const annotationsCopy = [...annotations]
    annotationsCopy.splice(index, 1)
    setSelectedAnnotation(null)
    setAnnotations(annotationsCopy)
  }

  // Tried extension #1
  function addAnnotation(annotation) {
    setAnnotations([...annotations, annotation])
  }


  return {
    annotations,
    setAnnotations,
    selectedAnnotation,
    setSelectedAnnotation,
    selectedImageIndex,
    setSelectedImageIndex,
    imageSrc,
    deleteAnnotation,
    addAnnotation,
  }
}
